<template>
    <section class="section pb-0 section-components">
        <div class="py-4 bg-secondary">
            <div class="container">
                <!-- Inputs (alternative) -->
                <div style="display: block; width: 100%;">
                    <el-row :gutter="15">
                        <el-col :xs="7" :sm="4" :md="3" :lg="2" class="mb-3 mb-lg-10">
                            <div class="card card-lift shadow border-0 card-img_tab_height">
                                <a href="https://president.uz/uz" target="_blank" title="Bosh Prokuratura Akademiyasi">
                                    <img v-lazy="'img/ill/prezident.jpg'" class="card-img_tabimg">
                                </a>
                            </div>
                        </el-col>
                        <el-col :sm="20" :md="10" :lg="6" class="mb-3 mb-lg-10">
                            <router-link to="/">
                                <div class="card card-lift shadow border-0 card-img_tab_h_text">
                                    <span class="card_new_span">{{$t('homepage.prezident_gap')}}</span>
                                    <br>
                                    <span style="float: right;">{{$t('homepage.prezident')}}</span>
                                </div>
                            </router-link>
                        </el-col>
                        <el-col :sm="12" :md="11" :lg="6" class="mb-3 mb-lg-10">
                            <router-link to="/main_page_panel2">
                                <div class="card card-lift shadow border-0"
                                     :class="selectedComponent==='MainPagePanel2' ? 'card_panel_active' : 'card-img_tab_card'">
                                    <img v-lazy="'img/icons/strategy.png'" class="image_card_icon">
                                    <span class="card_new_span_w vertical-center">{{$t('homepage.strategy')}}</span>
                                </div>
                            </router-link>
                        </el-col>
                        <el-col :sm="12" :md="12" :lg="5" class="mb-3 mb-lg-10">
                            <router-link to="/main_page_panel3">
                                <div class="card card-lift shadow border-0"
                                     :class="selectedComponent==='MainPagePanel3' ? 'card_panel_active' : 'card-img_tab_card'">
                                    <img v-lazy="'img/icons/network_new.svg'" class="image_card_icon">
                                    <span class="card_new_span_w vertical-center">{{$t('homepage.initsiativ')}}</span>
                                </div>
                            </router-link>
                        </el-col>
                        <el-col :sm="24" :md="12" :lg="5" class="mb-3 mb-lg-10">
                            <router-link to="/main_page_panel4">
                                <div class="card card-lift shadow border-0"
                                     :class="selectedComponent==='MainPagePanel4' ? 'card_panel_active' : 'card-img_tab_card'">
                                    <img v-lazy="'img/icons/network.svg'" class="image_card_icon">
                                    <span class="card_new_span_w vertical-center">{{$t('homepage.sector')}}</span>
                                </div>
                            </router-link>
                        </el-col>
                    </el-row>
                </div>
                <div>
                    <el-row :gutter="15">
                        <el-col :sm="24" :md="24" :lg="19">
                            <template v-if="isMainPage">
                                <main-page-panel1 ref="mainPagePanel"></main-page-panel1>
                            </template>
                            <template v-else>
                                <router-view></router-view>
                            </template>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="5" class="mb-lg-10">
                            <div style="text-align: center;">
                                <div class="card card-lift shadow border-0 card-img_card_calendar">
                                    <h5 class="card_new_title">{{$t('homepage.calendar')}}</h5>
                                    <div>
                                        <v-calendar :attributes="attributes" @dayclick="onDayClick" is-expanded style="border: 0px; margin-left: -7px;"></v-calendar>
                                    </div>
                                </div>
                                <router-link to="/pressservice" class="mt-3 button_new_m btnnew_primary">
                                    {{$t('homepage.button_news')}}
                                </router-link>
                            </div>
                            <div class="py-2" style="text-align: center;">
                                <div class="card card-lift shadow border-1 card-img_card_info">
                                    <img src="img/ill/pro_bino_mini.jpg" class="card-img-info_top">
                                    <h5 class="card_new_title_info">{{$t('homepage.bosh_address')}}</h5>
                                    <span class="card_new_span_info">{{$t('homepage.bosh_address1')}}</span>
                                    <a href="https://www.google.com/maps/place/General+Prosecutor's+Office+of+Republic+of+Uzbekistan/@41.307013,69.2896229,17.75z/data=!4m5!3m4!1s0x0:0x87547e5307b77db5!8m2!3d41.3077831!4d69.2877124"><span class="card_new_link_info">{{$t('homepage.bosh_map')}}</span></a>
                                    <h5 class="card_new_title_info">{{$t('homepage.bosh_map1')}}</h5>
                                    <span class="card_new_span_info">{{$t('homepage.bosh_map2')}}</span>
                                    <span class="card_new_span_info" style="margin-top: 6px;">{{$t('homepage.bosh_phones')}}</span>
                                    <span class="card_new_span_info">{{$t('homepage.bosh_faks')}}</span>
<!--                                    <span class="card_new_span_info" style="margin-top: 6px;">{{$t('homepage.bosh_obr')}}</span>-->
                                    <span class="card_new_span_info" style="margin-top: 6px;">{{$t('homepage.bosh_rejim')}}</span>
                                    <span class="card_new_span_info">9:00-18:00</span>
                                    <span class="card_new_span_info">{{$t('homepage.bosh_obed')}} </span>
                                    <span class="card_new_span_info">13:00-14:00</span>
                                </div>
                                <router-link to="/rahbariyat_tashriflar"
                                             class="mt-2 button_new_m btnnew_primary">
                                    {{$t('homepage.visit_table')}}
                                </router-link>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div>
                    <h5 class="card_new_title_shadow mb-2">{{$t('homepage.foydali')}}</h5>
                    <el-row :gutter="10">
                        <el-col :sm="12" :md="8" :lg="4" class="mb-2 mb-lg-2">
                            <a href="https://president.uz/uz">
                                <div class="card card-lift shadow border-0 card-img_gov">
                                    <img v-lazy="'img/ill/gerb_mini.png'" class="image_card_img_min">
                                    <span class="card_img_gov_title vertical-center">{{$t('resource_link.link')}}</span>
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="4" class="mb-2 mb-lg-2">
                            <a href="https://pm.gov.uz/uz#/">
                                <div class="card card-lift shadow border-0 card-img_gov">
                                    <img v-lazy="'img/ill/prezident_murojaat.png'" class="image_card_img_full">
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="4" class="mb-2 mb-lg-2">
                            <a href="https://www.gov.uz/uz">
                                <div class="card card-lift shadow border-0 card-img_gov">
                                    <img v-lazy="'img/ill/portal_b.jpg'" class="image_card_img_min">
                                    <span class="card_img_gov_title vertical-center" style="color: #7f7f7f;">{{$t('resource_link.link1')}}</span>
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="4" class="mb-2 mb-lg-2">
                            <a href="https://business.gov.uz/">
                                <div class="card card-lift shadow border-0 card-img_gov">
                                    <img v-lazy="'img/ill/bosh_vazir.png'" class="image_card_img_full">
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="4" class="mb-2 mb-lg-2">
                            <a href="http://parliament.gov.uz/uz/">
                                <div class="card card-lift shadow border-0 card-img_gov">
                                    <img v-lazy="'img/ill/gerb_mini.png'" class="image_card_img_min">
                                    <span class="card_img_gov_title vertical-center" style="color: #002060;">{{$t('resource_link.link2')}}</span>
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="4" class="mb-2 mb-lg-2">
                            <a href="http://senat.uz/uz">
                                <div class="card card-lift shadow border-0 card-img_gov">
                                    <img v-lazy="'img/ill/gerb_mini.png'" class="image_card_img_min">
                                    <span class="card_img_gov_title vertical-center" style="color: #0070c0;">{{$t('resource_link.link3')}}</span>
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="4" class="mb-2 mb-lg-2">
                            <a href="http://sud.uz/">
                                <div class="card card-lift shadow border-0 card-img_gov">
                                    <img v-lazy="'img/ill/gerb_mini.png'" class="image_card_img_min">
                                    <span class="card_img_gov_title vertical-center" style="color: #7f7f7f;">{{$t('resource_link.link4')}}</span>
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="4" class="mb-2 mb-lg-2">
                            <a href="https://strategy.uz/">
                                <div class="card card-lift shadow border-0 card-img_gov">
                                    <img v-lazy="'img/ill/strategy.png'" class="image_card_img_min">
                                    <span class="card_img_gov_title vertical-center" style="color: #7030a0;">{{$t('resource_link.link5')}}</span>
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="4" class="mb-2 mb-lg-2">
                            <a href="https://proacademy.uz/uz-lat/#main_section">
                                <div class="card card-lift shadow border-0 card-img_gov">
                                    <img v-lazy="'img/ill/academy_mini.png'" class="image_card_img_min">
                                    <span class="card_img_gov_title vertical-center" style="color: #394769;">{{$t('resource_link.link6')}}</span>
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="4" class="mb-2 mb-lg-2">
                            <a href="https://mib.uz/home">
                                <div class="card card-lift shadow border-0 card-img_gov">
                                    <img v-lazy="'img/ill/mib_mini.png'" class="image_card_img_min">
                                    <span class="card_img_gov_title vertical-center" style="color: #002060;">{{$t('resource_link.link7')}}</span>
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="4" class="mb-2 mb-lg-2">
                            <a href="https://prodepartament.uz/">
                                <div class="card card-lift shadow border-0 card-img_gov">
                                    <img v-lazy="'img/ill/departament_mini.png'" class="image_card_img_min">
                                    <span class="card_img_gov_title vertical-center" style="color: #002060;">{{$t('resource_link.link8')}}</span>
                                </div>
                            </a>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="4" class="mb-2 mb-lg-2">
                            <a href="https://my.gov.uz/uz">
                                <div class="card card-lift shadow border-0 card-img_gov">
                                    <img v-lazy="'img/ill/gov_uz.png'" class="image_card_img_min">
                                    <span class="card_img_gov_title vertical-center" style="color: #7030a0;">{{$t('resource_link.link9')}}</span>
                                </div>
                            </a>
                        </el-col>
                    </el-row>
                </div>

            </div>
        </div>
    </section>
</template>
<script>
    import MainPagePanel1 from "./MainPagePanels/MainPagePanel1";
    import MainPagePanel2 from "./MainPagePanels/MainPagePanel2";
    import MainPagePanel3 from "./MainPagePanels/MainPagePanel3";
    import MainPagePanel4 from "./MainPagePanels/MainPagePanel4";

    export default {
        name: "MainPage",
        components: {MainPagePanel1, MainPagePanel2, MainPagePanel3, MainPagePanel4},
        data() {
            return {
                selectedDate: "",
                days: [],
                selectedComponent: null,
                isMainPage: true,
                selectedRegion: 36,
                regionCodes: {
                    26: "Андижон вилояти",
                    27: "Бухоро вилояти",
                    28: "Жиззах вилояти",
                    29: "Қашқадарё вилояти",
                    30: "Қорақалпоғистон Республикаси",
                    31: "Навоий вилояти",
                    32: "Наманган вилояти",
                    33: "Самарқанд вилояти",
                    34: "Сирдарё вилояти",
                    35: "Сурхондарё вилояти",
                    36: "Тошкент вилояти",
                    37: "Тошкент шаҳри",
                    38: "Фарғона вилояти",
                    39: "Хоразм вилояти"
                },
                regionData: {
                    26: [
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Andijan\"",
                        }
                    ],
                    27: [
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Бухоро вилояти\"",
                        }
                    ],
                    28: [
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Жиззах вилояти\"",
                        }
                    ],
                    29: [
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Қашқадарё вилояти\"",
                        }
                    ],
                    30: [
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Қорақалпоғистон Республикаси\"",
                        }
                    ],
                    31: [
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Навоий вилояти\"",
                        }
                    ],
                    32: [
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Наманган вилояти\"",
                        }
                    ],
                    33: [
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Самарқанд вилояти\"",
                        }
                    ],
                    34: [
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Сирдарё вилояти\"",
                        }
                    ],
                    35: [
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Сурхондарё вилояти\"",
                        }
                    ],
                    36: [
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Тошкент вилояти\"",
                        },
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Тошкент вилояти\"",
                        }
                    ],
                    37: [
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Тошкент шаҳри\"",
                        }
                    ],
                    38: [
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Фарғона вилояти\"",
                        }
                    ],
                    39: [
                        {
                            photo: 'img/theme/tashnet2.jpg',
                            tel: "+99871 202-10-07",
                            fax: "+99871 202-10-07",
                            address: "г. andijan, Чиланзарский район, ул. Чилонзор, д. 6",
                            orientir: "\"Хоразм вилояти\"",
                        }
                    ],
                },
                series: [44, 55, 13],
                chartOptions: {
                    labels: ['Shaxsiy qabul', 'Yozma murojaatlar', 'elektron murojaat'],
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                }
            }
        },
        watch: {
            $route(to, from) {
                this.isMainPage = 'components' === to.name;
                this.selectedComponent = to.name;
            }
        },
        computed: {
            dates() {
                return this.days.map(day => day.date);
            },
            attributes() {
                return this.dates.map(date => ({
                    highlight: true,
                    dates: date,
                }));
            },
        },
        methods: {
            onDayClick(day) {
                if (this.days.length > 0 && day.id === this.days[0].id) {
                    this.days = [];
                    this.selectedDate = "";
                } else {
                    this.days = [];
                    const idx = this.days.findIndex(d => d.id === day.id);
                    if (idx >= 0) {
                        this.days.splice(idx, 1);
                    } else {
                        this.days.push({
                            id: day.id,
                            date: day.date,
                        });
                    }
                    this.selectedDate = this.days[0].id;
                }
                let {mainPagePanel} = this.$refs;
                if (mainPagePanel) {
                    console.log("-----")
                    mainPagePanel.onDateChange(this.selectedDate);
                }
            },
            onRegionSelect(ids) {
                if (this.selectedRegion !== ids[0]) {
                    this.selectedRegion = ids[0];
                    // this.counts.prosecutors = Math.floor(Math.random() * 3);
                    // this.counts.department = Math.floor(Math.random() * 2);
                    // this.counts.bureau = Math.floor(Math.random() * 2);
                    // this.counts.inspectorate = Math.floor(Math.random() * 3);
                } /*else {
                this.selectedRegion = -1;
            }*/
            },
            incrementVisit() {
                // this.$axios.post(`http://172.18.45.189:8080/api/visit/create-new-visit`).then(response => {});
                this.$axios.post(`https://www.prokuratura.uz/api/visit/create-new-visit`).then(response => {});
            }
        },
        mounted() {
            this.selectedComponent = null;
        },
        created() {
            this.incrementVisit();
        }
    };
</script>
<style scoped>
    @import url(../../assets/css/custom.scss);

    hr {

        border: none;
        border-left: 1px solid #00b0f0;
        height: 14px;
        margin: 4px 5px;
        width: 1px;
    }

    blockquote {
        margin: 0 0 0rem;
    }

    .button_new_m {
        display: block;
        white-space: inherit;
        line-height: 1;
        font-weight: 500;
        margin-right: 0px !important;
        margin-left: 0px !important;
    }

    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 150px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: transparent;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: transparent;
    }

    .st1 {
        fill: #96b4d3;
        stroke: #fff;
        stroke-miterlimit: 10;
    }

    .st1:hover {
        fill: #04ad00;
        cursor: pointer;
    }

    .st1.active {
        fill: #21ad69;
    }
    .btnnew_primary {
        text-align: center;
        white-space: normal;
        vertical-align: middle;
        user-select: none;
        font-size: 15px;
        padding: 0.625rem 1.25rem;
        border-radius: 0px;
        color: #fff;
        background-color: #96b4d3;
        border-color: #96b4d3;
        margin-bottom: .5rem;
        box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    }
</style>
